import React, {useEffect, useState} from 'react';
import { BlogPost } from '@/components/blog/blog';
import blogPosts from "../../article_manifest.json";
import "./learn.css";

const Learn:React.FC = () => {
    const [posts, setPosts] = useState<BlogPost[]>(
        blogPosts.map(post => ({...post}))
    );
    
    return (
        <div className="learn-container">
            <div className="filters-wrapper">
							<hr />
								<div className="filters">
									<span id='filter-span'>Quick Filters</span>
              	  <span>AI</span>
              	  <span>Diagnostics</span>
              	  <span>Tutorials</span>
								</div>
              <hr />
            </div>
            <div className="articles-wrapper">
                {posts.map(post => (
                    <article key={post.id} className="article-card">
                        <div className="article-image-container">
                            <img src={post.imageUrl} alt={post.title} />
                            <div className='article-tag'>{post.tag}</div>
                        </div>

                        <div className='article-content'>
                            <span className="article-date">{post.date}</span>
                            <h3 className="article-title">{post.title}</h3>
                            <div className="article-text">
                                <p className="article-snippet">{post.snippet}</p>
                                <a className='read-more' href={post.content}>Read More</a>
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    )
}

export default Learn;
